import
  React
from 'react';

import
  styled
from 'styled-components';

import {
  PropTypes
} from 'prop-types';

import {
  HFillContainer,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../../../constants';

const Container = styled(VContainer)`
  border-bottom: ${props => props.borderBottom};
`;

export const AdvanceHistoryCard = props => {

  return (

    <Container
      margin={props.margin}
      padding={props.padding}
      borderBottom={`solid 1px ${CustomColors.Grey5}`}>

      <HFillContainer>

        <Text
          color={CustomColors.Grey9}
          fontWeight={'600'}
          fontSize={'16px'}
          padding={'0 20px 0 0'}>

          {props.description}
        </Text>

        <VContainer
          margin={'0 0 0 auto'}>

          <Text
            color={CustomColors.Grey9}
            fontSize={'14px'}>

            {props.date}
          </Text>
        </VContainer>

      </HFillContainer>

      <Text
        color={CustomColors.Grey9}
        fontSize={'14px'}
        padding={'8px 0 0'}>

        {`Access fee: ${props.accessFee}`}
      </Text>

      <Text
        color={CustomColors.Grey9}
        fontSize={'14px'}
        padding={'8px 0 0'}>

        {`Total repayments: ${props.totalRepayment}`}
      </Text>
    </Container>
  );
};

AdvanceHistoryCard.propTypes = {
  description: PropTypes.string.isRequired,
  accessFee: PropTypes.string.isRequired,
  totalRepayment: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  margin: PropTypes.string,
  padding: PropTypes.string
};

AdvanceHistoryCard.defaultProps = {
  margin: '0px',
  padding: '20px 0'
};